/* X-VENERDI 18/10/2026 (Q4, P2). /pages/venerdi-nero, the filter «Tutte · Tenute · Buttate». It hides the images with the other verdict
   and a graphic left with no image, and keeps the choice in the address (#tenute, #buttate) so a link can open the page on it.
   Without JavaScript every image is shown and the filter stays invisible (it keeps its place, so nothing moves when it appears). */
(function () {
  var gruppo = document.querySelector('[data-bhv-filtro]');
  if (!gruppo) return;
  document.documentElement.classList.add('bhv-js');
  var bottoni = gruppo.querySelectorAll('.bhv-filtro__b');
  var hash = { tenuta: '#tenute', buttata: '#buttate' };
  function applica(valore) {
    bottoni.forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.valore === valore ? 'true' : 'false'); });
    document.querySelectorAll('[data-bhv-capo]').forEach(function (capo) {
      var viste = 0;
      capo.querySelectorAll('.bhv-tavola').forEach(function (t) {
        var si = valore === 'tutte' || t.dataset.esito === valore;
        t.hidden = !si;
        if (si) viste++;
      });
      capo.hidden = viste === 0;
    });
  }
  bottoni.forEach(function (b) {
    b.addEventListener('click', function () {
      applica(b.dataset.valore);
      try { history.replaceState(null, '', hash[b.dataset.valore] || location.pathname + location.search); } catch (e) {}
    });
  });
  if (location.hash === '#tenute') applica('tenuta');
  else if (location.hash === '#buttate') applica('buttata');
})();
